const webp = function (url) {
  if (url.includes("png")) {
    return url.split(".png").join(".webp");
  } else {
    return url.split(".jpg").join(".webp");
  }
};

export { webp };
